@if (formGroup) {
  <div class="form-container" [formGroup]="formGroup">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <div class="control-div">
          <div class="control-label-container">
            <label class="control-label"> Name </label>
          </div>
          <clickatell-form-validation [controlName]="'name'"
          [form]="formGroup"></clickatell-form-validation>
          <input class="control-input" activeForm [activeForm]="formGroup" id="name"
            [formControlName]="'name'" placeholder="Enter name"/>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <clickatell-form-validation [controlName]="'description'"
            [form]="formGroup"></clickatell-form-validation>
            <input class="control-input" activeForm [activeForm]="formGroup" id="description"
              [formControlName]="'description'" placeholder="Enter description"/>
            </div>
            @if (showFromNumber) {
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> From Number </label>
                </div>
                <clickatell-form-validation [controlName]="'fromNumber'"
                [form]="formGroup"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="formGroup" id="fromNumber"
                  [formControlName]="'fromNumber'" placeholder="Enter from number"/>
                </div>
              }
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Numbers </label>
                </div>
                <clickatell-form-validation [controlName]="'numbers'"
                [form]="formGroup"></clickatell-form-validation>
                <input class="control-input" activeForm [activeForm]="formGroup" id="numbers"
                  [formControlName]="'numbers'" placeholder="Enter the number to opt out."/>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Channel </label>
                  </div>
                  <clickatell-form-validation [controlName]="'channel'"
                  [form]="formGroup"></clickatell-form-validation>
                  <mat-select
                    #deleteOptOutAction
                    class="control-dropdown"
                    id="deleteOptOutAction"
                    [placeholder]="'Select an option'"
                    [formControlName]="'channel'"
                    hideSingleSelectionIndicator>
                    <mat-option value="SMS">SMS</mat-option>
                    <mat-option value="WHATSAPP">WHATSAPP</mat-option>
                  </mat-select>
                </div>
              </ng-container>
            </clickatell-expansion-panel>
            <clickatell-expansion-panel>
              <ng-container header>
                <mat-panel-title>
                  Logic
                </mat-panel-title>
              </ng-container>
              <ng-container body>
                <div class="control-result">
                  <div class="control-result-header">
                    Success
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector id="success" [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'success'"
                          [form]="formGroup"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
                <div class="control-result">
                  <div class="control-result-header">
                    Error
                  </div>
                  <div class="control-result-container">
                    <div class="control-div">
                      <label class="control-label">
                        <span class="pont-to">Point To</span>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                      </label>
                      @if (nodeFlowDetails) {
                        <next-selector id="error" [canEditFlows]="canEdit.canEditFlows"
                          [selectorType]="'both'"
                          [flowSteps]="nodeFlowDetails.currentFlowSteps"
                          [flows]="nodeFlowDetails.flows"
                          [name]="'error'"
                          [form]="formGroup"
                          [stepId]="nodeFlowDetails.stepId">
                        </next-selector>
                      }
                    </div>
                  </div>
                </div>
              </ng-container>
            </clickatell-expansion-panel>
          </div>
        }